import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import DataTable from "react-data-table-component";
import { useAuth } from "../AuthContext";
import axios from "axios";
import iziToast from "izitoast";
import Footer from "./Footer";

export const ViewResult = () => {

    const { apipath, filepath, logout, goBack } = useAuth();
    const navigate = useNavigate();
    const token = localStorage.getItem('token');
    const userType = localStorage.getItem('userType');
    const [tests, setTests] = useState([]);
    const [tdata, setTdata] = useState({});
    const [filteredData, setFilteredData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isView, setIsView] = useState(false);
    const [viewData, setViewData] = useState({});
    const [filters, setFilters] = useState('');
    const resultId = localStorage.getItem('resultId');
    if (!resultId) {
        navigate('/results');
    }
    // localStorage.removeItem('answers');

    const handleFilterChange = (e) => {
        const { value } = e.target;
        setFilters(value);
    }

    const applyFilters = () => {
        console.log(filters);
        let filteredItems = [...tests];
        const filterValue = filters.toLowerCase();
        if (filterValue) {
            filteredItems = filteredItems.filter(item => {
                return Object.values(item).some(val =>
                    typeof val === 'string' && val.toLowerCase().includes(filterValue)
                );
            });
        }
        setFilteredData(filteredItems);
    }
    useEffect(() => {
        applyFilters();
    }, [filters]);

    const getTests = async () => {
        setIsLoading(true);
        try {
            const response = await axios.post(
                apipath + '/view_result',
                { 'resultId': resultId },
                {
                    headers: {
                        Authorization: 'Bearer ' + token
                    }
                }
            );
            console.log(response.data.results);
            if (response.data.status === "unauthentic") {
                iziToast.error({
                    message: response.data.message,
                    position: "topCenter"
                });
                logout();
            }
            if (response.data.status === "false") {
                iziToast.error({
                    'message': response.data.message,
                    'position': 'topCenter'
                });
                return false;
            }
            setTests(response.data.results);
            setTdata(response.data.test);
            setFilteredData(response.data.results);
        }
        catch (error) {
            // console.error('Error fetching data:', error);
            if (error.status === 401) {
                iziToast.error({
                    message: "Un-Authorised! Please Login.",
                    position: "topCenter"
                });
                logout();
            }
            else {
                iziToast.error({
                    message: error,
                    position: 'topCenter'
                });
            }

        } finally {
            setIsLoading(false);
        }
    }
    useEffect(() => {
        getTests();
    }, []);

    const downloadResult = async (tid) => {
        setIsLoading(true);
        try {
            const response = await axios.post(
                apipath + '/download_result',
                { 'id': tid },
                {
                    responseType: "blob",
                    headers: {
                        Authorization: 'Bearer ' + token
                    }
                }
            );
            // console.log(response.data);
            if (response.data.status === "unauthentic") {
                iziToast.error({
                    message: response.data.message,
                    position: "topCenter"
                });
                logout();
            }
            if (response.data.status === "false") {
                iziToast.error({
                    'message': response.data.message,
                    'position': 'topCenter'
                });
                return false;
            }
            console.log(response.data);
            const blob = new Blob([response.data], { type: "application/pdf" });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'result.pdf';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);

            // const url = response.data.pdf;
            // const link = document.createElement("a");
            // link.href = url;
            // link.target = "_blank";
            // link.setAttribute("download", "student_result.pdf"); // File name
            // document.body.appendChild(link);
            // link.click();
            // document.body.removeChild(link);
        }
        catch (error) {
            console.error('Error fetching data:', error);
            if (error.status === 401) {
                iziToast.error({
                    message: "Un-Authorised! Please Login.",
                    position: "topCenter"
                });
                logout();
            }
            else {
                iziToast.error({
                    message: error,
                    position: 'topCenter'
                });
            }

        } finally {
            setIsLoading(false);
        }
    }

    const exportResult = async (tid) => {
        setIsLoading(true);
        try {
            const response = await axios.post(
                apipath + '/export_result',
                { 'id': resultId },
                {
                    responseType: "blob",
                    headers: {
                        Authorization: 'Bearer ' + token
                    }
                }
            );
            // console.log(response.data);
            if (response.data.status === "unauthentic") {
                iziToast.error({
                    message: response.data.message,
                    position: "topCenter"
                });
                logout();
            }
            if (response.data.status === "false") {
                iziToast.error({
                    'message': response.data.message,
                    'position': 'topCenter'
                });
                return false;
            }
            console.log(response.data);
            const blob = new Blob([response.data], { type: "application/zip" });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'results.zip';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        }
        catch (error) {
            console.error('Error fetching data:', error);
            if (error.status === 401) {
                iziToast.error({
                    message: "Un-Authorised! Please Login.",
                    position: "topCenter"
                });
                logout();
            }
            else {
                iziToast.error({
                    message: error,
                    position: 'topCenter'
                });
            }

        } finally {
            setIsLoading(false);
        }
    }

    const [searchText, setSearchText] = useState("");

    const showResult = (data) => {
        setViewData(data);
        setIsView(true);
    }
    const hideResult = () => {
        setViewData({});
        setIsView(false);
    }

    const subjectResult = () => {
        if (viewData.subject_result) {
            const subjdata = JSON.parse(viewData.subject_result);
            return (
                Object.keys(subjdata).map(subject => (
                    <>
                        <tr className="border hover:bg-teal-100">
                            <td className="border-2 border-teal-900 p-2 font-bold bg-teal-500 text-white">{subject}</td>
                            {Object.entries(subjdata[subject]).map(([key, value]) => (
                                <td className="text-center border-2 border-teal-900 p-2">{`${value}`}</td>
                            ))}
                            <hr className="w-full" />
                        </tr>
                    </>
                ))
            );
        } else {
            return null;
        }
    };

    const columns = [
        { name: "Student Name", selector: (row) => row.user_name, sortable: true, },
        { name: "Roll No", selector: (row) => row.roll_no, sortable: true, },
        { name: "Organization", selector: (row) => row.organization_name, sortable: true, },
        { name: "Exam", selector: (row) => row.exam_name, sortable: true, },
        { name: "Test", selector: (row) => row.test_name, sortable: true, },
        // { name: "Test Time", selector: (row) => row.start_time, sortable: true, },
        // { name: "Questions", selector: (row) => row.total_questions, sortable: true, },
        // { name: "Attempted", selector: (row) => row.attempted, sortable: true, },
        // { name: "Correct", selector: (row) => row.correct_questions, sortable: true, },
        // { name: "Wrong", selector: (row) => row.incorrect_questions, sortable: true, },
        // { name: "Total Marks", selector: (row) => row.total_marks, sortable: true, },
        // { name: "Marks Obtained", selector: (row) => row.marks_obtained, sortable: true, },
        { name: "Percentage", selector: (row) => row.percentage + "%", sortable: true, },
        {
            name: "Action", selector: (row) => <>
                <button onClick={() => showResult(row)} className="border rounded bg-teal-600 text-white hover:bg-teal-700 p-1 px-2">View</button>
                {(userType === 'super_admin') ? <><button onClick={() => downloadResult(row.user_test)} className="border rounded bg-green-600 text-white hover:bg-green-700 p-1 px-2">Download</button></> : (tdata.download_status === 'true') ? <>
                    <button onClick={() => downloadResult(row.user_test)} className="border rounded bg-green-600 text-white hover:bg-green-700 p-1 px-2">Download</button>
                </> : ""}
            </>, sortable: true, width: '200px'
        },
    ];
    return (
        <>
            <span className={(isView) ? "flex items-center bg-teal-900/90 justify-center  fixed top-0 left-0 w-full h-screen z-50 overflow-auto" : "hidden"}>
                <div className="relative flex w-full md:w-3/4 h-screen space-y-1 bg-white md:max-h-[90vh] overflow-auto border rounded-lg">
                    <button onClick={() => hideResult()} className="absolute p-1 bg-red-600 text-white text-lg font-bold px-2 rounded-md top-0 right-0 z-50">X</button>
                    <div className="relative flex flex-row w-full flex-wrap h-screen space-y-1 bg-white md:max-h-[89vh] overflow-auto p-4 md:px-14">
                        <h3 className="w-full font-bold text-xl text-teal-800 pb-4 text-center">Student Result</h3>
                        <div className="w-full overflow-auto">
                            <table className="w-full">
                                <tr className="border hover:bg-teal-100">
                                    <th className="text-start border-2 border-teal-900 p-2">Name</th>
                                    <td className="border-2 border-teal-900 p-2">{viewData.user_name}</td>
                                    <td className="border-2 border-teal-900 p-2 text-center " rowSpan={4} colSpan={2}>
                                        {viewData.user ? <>
                                            <img className="w-40 block ms-auto" src={`${filepath + "/public/userImages/org_" + viewData.organization + "/" + viewData.user?.photo}`} />
                                        </> : ""}
                                    </td>
                                </tr>
                                <tr className="border hover:bg-teal-100">
                                    <th className="text-start border-2 border-teal-900 p-2">Roll No.</th>
                                    <td className="border-2 border-teal-900 p-2">{viewData.roll_no}</td>
                                </tr>
                                <tr className="border hover:bg-teal-100">
                                    <th className="text-start border-2 border-teal-900 p-2">Organization</th>
                                    <td className="border-2 border-teal-900 p-2">{viewData.organization_name}</td>
                                </tr>
                                <tr className="border hover:bg-teal-100">
                                    <th className="text-start border-2 border-teal-900 p-2">Exam</th>
                                    <td className="border-2 border-teal-900 p-2">{viewData.exam_name}</td>
                                </tr>
                                <tr className="border hover:bg-teal-100">
                                    <th className="text-start border-2 border-teal-900 p-2">Test</th>
                                    <td className="border-2 border-teal-900 p-2">{viewData.test_name}</td>
                                    <th className="text-start border-2 border-teal-900 p-2">Exam Date</th>
                                    <td className="border-2 border-teal-900 p-2">{viewData.start_time}</td>
                                </tr>
                                {/* <tr className="border hover:bg-teal-100">
                            </tr> */}
                                <tr className="border hover:bg-teal-100">
                                    <th className="text-start border-2 border-teal-900 p-2">Total Marks</th>
                                    <td className="border-2 border-teal-900 p-2">{viewData.total_marks}</td>
                                    <th className="text-start border-2 border-teal-900 p-2">Total Questions</th>
                                    <td className="border-2 border-teal-900 p-2">{viewData.total_questions}</td>
                                </tr>
                                <tr className="border hover:bg-teal-100">
                                    <th className="text-start border-2 border-teal-900 p-2">Attempted</th>
                                    <td className="border-2 border-teal-900 p-2">{viewData.attempted}</td>
                                    <th className="text-start border-2 border-teal-900 p-2">Un-Attempted</th>
                                    <td className="border-2 border-teal-900 p-2">{viewData.unattempted}</td>
                                </tr>
                                <tr className="border hover:bg-teal-100">
                                    <th className="text-start border-2 border-teal-900 p-2">Correct</th>
                                    <td className="border-2 border-teal-900 p-2">{viewData.correct_questions}</td>
                                    <th className="text-start border-2 border-teal-900 p-2">Wrong</th>
                                    <td className="border-2 border-teal-900 p-2">{viewData.incorrect_questions}</td>
                                </tr>
                                <tr className="border hover:bg-teal-100">
                                    <th className="text-start border-2 border-teal-900 p-2">Marks Obtained</th>
                                    <td className="border-2 border-teal-900 p-2">{viewData.marks_obtained}</td>
                                    <th className="text-start border-2 border-teal-900 p-2">Percentage</th>
                                    <td className="border-2 border-teal-900 p-2">{viewData.percentage}</td>
                                </tr>
                            </table>
                        </div>

                        {/* <div className="p-3 font-medium w-full text-lg text-center text-teal-800">Subject Result</div> */}
                        {/* <hr className="w-full"></hr> */}
                        <div className="w-full overflow-auto">
                            <table className="table-auto w-full">
                                <thead>
                                    <tr className="border bg-teal-500 text-white">
                                        <th className="border-2 border-teal-900 p-2 text-left">Subject</th>
                                        <th className="border-2 border-teal-900 p-2">Total Ques.</th>
                                        <th className="border-2 border-teal-900 p-2">Total Marks</th>
                                        <th className="border-2 border-teal-900 p-2">Attempted</th>
                                        <th className="border-2 border-teal-900 p-2">Un-Attempted</th>
                                        <th className="border-2 border-teal-900 p-2">Correct</th>
                                        <th className="border-2 border-teal-900 p-2">Wrong</th>
                                        <th className="border-2 border-teal-900 p-2">Marks Obt.</th>
                                        <th className="border-2 border-teal-900 p-2">%age</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {subjectResult()}
                                </tbody>
                            </table>
                        </div>
                        {/* <div className="p-1 w-1/2"><p>{console.log(JSON.parse(viewData.subject_result))}</p></div>
                        <hr className="w-full"></hr> */}
                    </div>
                </div>
            </span>
            <span className={(isLoading) ? "flex items-center text-white bg-gray-400/75 justify-center fixed top-0 left-0 w-full h-screen z-50" : "hidden"}>
                <svg
                    className="w-5 h-5 mr-2 animate-spin"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                >
                    <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                    ></circle>
                    <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8v4l3-3-3-3V4a10 10 0 1010 10h-4l3 3 3-3h-4a8 8 0 01-8 8z"
                    ></path>
                </svg>Loading...
            </span>
            {<Navbar />}

            <div class="flex flex-col md:flex-row">
                {<Sidebar activePage={"results"} />}
                <div class="main-content flex-1 bg-gray-100 pb-24 md:pb-5 w-full md:w-4/5 lg:w-5/6 pt-16 md:pt-8">

                    <div class="bg-teal-700 pt-4">
                        <div class="rounded-tl-3xl bg-teal-600 p-2 shadow text-2xl text-white relative">
                            <h3 class="font-bold pl-2">
                            <i className="fa fa-arrow-left text-sm border-2 rounded absolute right-3 py-1 px-2 top-2 bg-teal-700 hover:bg-teal-800 cursor-pointer" title="go back" onClick={()=>goBack()}></i>Exam Result</h3>
                        </div>
                    </div>

                    <div class="flex flex-wrap">
                        <div class="w-full p-2">
                            {/* <h3 class="mb-3 font-semibold">Exam Result</h3> */}
                            <div className="flex flex-row items-center justify-between mb-3">
                                <input
                                    type="text"
                                    placeholder="Search..."
                                    value={searchText}
                                    onChange={() => handleFilterChange}
                                    className="p-1.5"
                                />
                                {(userType === 'super_admin') ? <>
                                    <button onClick={() => exportResult()} className="p-1 px-2 text-sm font-bold text-teal-700 rounded-lg border-2 border-teal-700 hover:bg-teal-700 hover:text-white hover:border-transparent">
                                        Download All
                                    </button>
                                </> : (tdata.download_status === 'true') ? <>
                                    <button onClick={() => exportResult()} className="p-1 px-2 text-sm font-bold text-teal-700 rounded-lg border-2 border-teal-700 hover:bg-teal-700 hover:text-white hover:border-transparent">
                                        Download All
                                    </button>
                                </> : ""}
                            </div>

                            {/* Data Table */}
                            <DataTable
                                columns={columns}
                                data={filteredData}
                                pagination
                                highlightOnHover
                            />
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};